export default __webpack_public_path__ + "static/media/Legendry.61d2fe8f.svg";